import localKey from './localKey'

const devApiUrl = '/';

// const proApiUrl = 'https://100.api.fxzb.vip';
const proApiUrl = 'https://dev.100.api.fxzb.vip';
// const proApiUrl = 'http://192.168.110.201:8201';

const nodeDevEnv = process.env.NODE_ENV == 'development' ? true : false;



export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: '百米赛跑总后台',
    minSiteMame: 'C',
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 10000,
    cookiesExpires: 7,
    requestRetry: 4,
    requestRetryDelay: 800,
    tokenKey: 'Authorization',
    userInfoKey: 'USER_INFO',
    ...localKey
}
